<template>
    <div class="carousel">
      <div class="carousel-inner" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
        <div class="carousel-item" v-for="(item, index) in items" :key="index">
          <slot :item="item"></slot>
        </div>
      </div>
      <button @click="prev" class="carousel-control prev">‹</button>
      <button @click="next" class="carousel-control next">›</button>
    </div>
  </template>
  
  <script setup>
import { ref } from 'vue';

const props = defineProps({
  items: {
    type: Array,
    required: true,
  },
});

const currentIndex = ref(0);

const prev = () => {
  if (currentIndex.value === 0) {
    currentIndex.value = props.items.length - 1;
  } else {
    currentIndex.value--;
  }
};

const next = () => {
  if (currentIndex.value === props.items.length - 1) {
    currentIndex.value = 0;
  } else {
    currentIndex.value++;
  }
};
</script>
  
  <style scoped>
  @media (max-width: 900px) {
  .carousel {
    position: relative;
    width: 100%;
    overflow:hidden;
    
  }
  
  .carousel-inner {
    display: flex;
    transition: transform 1s ease-in-out;
  }
  
  .carousel-item {
    min-width: 100%;
    box-sizing: border-box;
  }
  
  .carousel-control {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(0, 0, 0, 0.678);
    color: rgb(255, 255, 255);
    font-size: 1rem;
    border: none;
    padding: 10px;
    cursor: pointer;
  }
  
  .prev {
    left: 7px;
  }
  
  .next {
    right: 7px;
  }  
}
  @media (min-width: 901px) {
  .carousel {
    position: relative;
    width: 100%;
    overflow:hidden;
    
  }
  
  .carousel-inner {
    display: flex;
    transition: transform 1s ease-in-out;
  }
  
  .carousel-item {
    min-width: 100%;
    box-sizing: border-box;
  }
  
  .carousel-control {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(0, 0, 0, 0.678);
    color: rgb(255, 255, 255);
    font-size: 1rem;
    border: none;
    padding: 20px;
    cursor: pointer;
  }
  
  .prev {
    left: 20px;
  }
  
  .next {
    right: 20px;
  }  
}
  </style>
  